import { useContext } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { PaymentMethodEnum, ProviderEnum } from '@/types/common';
import { AdyenPayForm } from './AdyenPayForm';
import { StripeGenericPayForm } from './StripeGenericPayForm';

export const AfterPayForm = () => {
  const { paymentMethodsSettings } = useContext(CheckoutContext);
  const afterPaySettings = paymentMethodsSettings.find(
    (paymentMethod) => paymentMethod.paymentMethodName === PaymentMethodEnum.AFTERPAY
  )!;
  if (!afterPaySettings) {
    throw new Error('AfterPay settings not found');
  }
  if (afterPaySettings.provider === ProviderEnum.STRIPE) {
    return <StripeGenericPayForm paymentMethod="afterpay_clearpay" />;
  }
  if (afterPaySettings.provider === ProviderEnum.ADYEN) {
    return <AdyenPayForm selectedPaymentMethod={PaymentMethodEnum.AFTERPAY} />;
  }
  throw new Error(`Unsupported provider for afterpay: ${afterPaySettings.provider}`);
};
